import React, { useState, useLayoutEffect } from 'react'
import collections from '../constants/collections'

import { Link } from 'gatsby'

import './site-nav.css'

const SiteNav = ({ pathname }) => {

  const useWindowSize = () => {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }

  const [width, height] = useWindowSize()

  const getRandomNumber = () => {
    return Date.now()
  }

  const sortedCollections = collections.sort((a, b) => a.id - b.id)

  const renderNavRows = (device) => {
  
  let finalArr = [], columns = []
  let push

  sortedCollections.forEach((curr, index) => {
    if(device === 'mobile') {
      if(index === 1 || index === 3 || index === 5) push = true
      else push = false
    }
    else {
      if(index === 2 || index === 5) push = true
      else push = false
    }
    // prepare the array
    columns.push(
      <><span>&nbsp;&nbsp;</span><Link className={`${pathname === `/collections/${curr.route}` ? 'underline bold' : ''}`} to={`/collections/${curr.route}`} state={ { refresh: getRandomNumber() } } >{width < 851 && curr.shortTitle ? curr.shortTitle : curr.title}</Link><span>&nbsp;&nbsp;|</span></>
    )

    // after three items add a new row
    if(push === true) {
      finalArr.push(<div className ="site-nav-row">|{columns}</div>)
      columns = []
    }
  })

  return finalArr

  }

  return(
    <div id="site-nav" style={pathname === '/info' ? { marginBottom: 0 } : null}>
      <div id={width < 651 ? `mobile-site-nav` : `desktop-site-nav`}>
        {renderNavRows('mobile')}
      </div>
      {/* <div id="desktop-site-nav">
        {renderNavRows('desktop')}
      </div> */}
    </div>
  )
}

export default SiteNav